/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Dropdown, Image, Row, Tag, Tooltip } from "antd";
import {
  AmountIcon,
  // CrossIcon,
  DeleteIcon,
  GreenCheckIcon,
  PenIcon,
  StarFilledIcon,
} from "../../../../atoms/CustomIcons";

import { useEffect, useRef, useState } from "react";
import { SelectedContactType } from "../../ducks/types";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { PopUp } from "../../../../atoms/PopUp";
import AddContactPopUp from "./PopUp";
import { SelectFieldWithButton } from "../../../../atoms/FormFields";
import { MoreOutlined } from "@ant-design/icons";
import { deleteClientContact } from "../../ducks/services";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { useAppDispatch } from "../../../../config/hooks";
import { getClientContacts, getPropertyDetails } from "../../ducks/actions";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { PhoneInput } from "react-international-phone";

interface PropsType {
  propertyContact: {
    label: string;
    value: string;
  }[];
  clientId: string | null;
  companyId: string;
  control: any;
  clientContactData: [];
  contactData?: [] | undefined;
  selectedClient: string | undefined;
  setSelectedContact: (contacts: SelectedContactType[] | null) => void;
  selectedContact: SelectedContactType[] | null;
  setValue: any;
  propertyId?: string;
}

export default function PropertyContact(props: PropsType) {
  const {
    propertyContact,
    clientId,
    companyId,
    clientContactData,
    control,
    selectedClient,
    selectedContact,
    setSelectedContact,
    setValue,
    propertyId,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [newContactPopUp, setNewContact] = useState<boolean>(false);
  const [contactIndex, setContactIndex] = useState<null | number>(null);
  const [tableRecord, setTableRecord] = useState<any>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  console.log("contactIndex", contactIndex, tableRecord);

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            setNewContact(true);
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //       }}
    //       icon={<CrossIcon />}
    //     >
    //       Remove from property
    //     </Button>
    //   ),
    // },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
    deleteClientContact(tableRecord?.id)
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setSelectedContact(
          selectedContact?.filter(
            (contact) => contact.id !== tableRecord?.id
          ) ?? null
        );
        const clientContactIds = (selectedContact ?? [])
          .filter((contact) => contact.id !== tableRecord?.id)
          .map((contact) => contact.id);
        setValue("client_contact_id", clientContactIds);
        setContactIndex(null);
        SuccessMessage("contact deleted");
        dispatch(getClientContacts(clientId as string));
        if (propertyId) {
          dispatch(getPropertyDetails(propertyId));
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const addNewContact = {
    visibility: newContactPopUp,
    class: "",
    content: (
      <AddContactPopUp
        onClose={() => {
          setNewContact(false);
          setContactIndex(null);
        }}
        companyId={companyId}
        clientId={clientId}
        setContacts={setSelectedContact}
        contactIndex={contactIndex}
        setContactIndex={setContactIndex}
        contacts={selectedContact ?? []}
        editData={
          contactIndex !== null ? selectedContact?.[contactIndex] : null
        }
      />
    ),
    width: 541,
    onCancel: () => {
      setNewContact(false);
    },
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>Are you sure you want to delete? This action cannot be undone.</>
        }
        btnText="Delete"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const contactChange = (value: string | number | readonly string[]) => {
    const filteredContact: SelectedContactType[] | null =
      clientContactData?.filter(
        (emp: { id: string }) =>
          Array.isArray(value) && value.some((v) => v === emp?.id)
      ) ?? null;

    setSelectedContact(filteredContact ?? null);
  };

  useEffect(() => {
    if (selectedContact && selectedContact?.length > 0) {
      const filteredContact: SelectedContactType[] | null =
        clientContactData?.filter(
          (emp: { id: string }) =>
            Array.isArray(selectedContact) &&
            selectedContact?.some((v: { id: string }) => v?.id === emp?.id)
        ) ?? null;
      setSelectedContact(filteredContact ?? null);
    } else {
      setSelectedContact(null);
      setValue("client_contact_id", []);
    }
  }, [clientContactData, setSelectedContact]);

  return (
    <>
      <Row gutter={20}>
        <Col span={24} style={{ marginBottom: "16px" }}>
          <h4 style={{ marginBottom: "4px" }}> Property contacts </h4>
          <p>People at the property your team coordinates and works with.</p>
        </Col>

        <Col span={24} style={{ marginBottom: "12px" }}>
          <SelectFieldWithButton
            fieldName="client_contact_id"
            control={control}
            selectOption={propertyContact}
            iProps={{
              placeholder: "Select existing or create a new one",
              mode: "multiple",
              disabled: selectedClient ? false : true,
            }}
            addItemText="Add contact"
            onAddItemClick={() => setNewContact(true)}
            onSelectChange={contactChange}
            differentClassName="custom_client_select"
          />
          {!selectedClient && (
            <p
              style={{ color: "#474C4D", fontSize: "11px", marginTop: "-16px" }}
            >
              Select client first. All property contacts belong to its client.
            </p>
          )}
        </Col>
        {selectedClient && (
          <Col span={24}>
            {selectedContact && selectedContact?.length > 0 ? (
              <div className="contact_wrapper">
                {selectedContact?.map((contact, i) => (
                  <Card key={contact?.id}>
                    <div className="titleBar">
                      <span className="userName">
                        {`${contact?.first_name ?? ""} ${
                          contact?.last_name ?? ""
                        }`}
                      </span>
                      <div className="actionBtns">
                        <Button
                          type="text"
                          onClick={() => {
                            const updated = selectedContact.map((c, idx) => {
                              if (idx === i) {
                                return { ...c, is_starred: !c.is_starred };
                              }
                              return { ...c, is_starred: false };
                            });
                            setSelectedContact(updated);
                            // setSelectedContact(
                            //   selectedContact?.map((contact, index) =>
                            //     index === i
                            //       ? {
                            //           ...contact,
                            //           is_starred: !contact.is_starred,
                            //         }
                            //       : contact
                            //   )
                            // );
                          }}
                          className={
                            contact?.is_starred
                              ? "activeIcon star"
                              : "notActiveIcon star"
                          }
                        >
                          <Tooltip title="The main point of contact from the client's side">
                            <StarFilledIcon />
                          </Tooltip>
                        </Button>
                        <Button
                          type="text"
                          onClick={() => {
                            setSelectedContact(
                              selectedContact.map((contact, index) =>
                                index === i
                                  ? {
                                      ...contact,
                                      is_signing: !contact.is_signing,
                                    }
                                  : contact
                              )
                            );
                          }}
                          className={
                            contact?.is_signing
                              ? "activeIcon sign"
                              : "notActiveIcon sign"
                          }
                        >
                          <Tooltip title="The contact responsible for signing documents and agreements">
                            <PenIcon />
                          </Tooltip>
                        </Button>
                        <Button
                          type="text"
                          onClick={() => {
                            setSelectedContact(
                              selectedContact.map((contact, index) =>
                                index === i
                                  ? {
                                      ...contact,
                                      is_billing: !contact.is_billing,
                                    }
                                  : contact
                              )
                            );
                          }}
                          className={
                            contact?.is_billing
                              ? "activeIcon invoice"
                              : "notActiveIcon invoice"
                          }
                        >
                          <Tooltip title="The contact responsible for handling invoices and payment-related communication">
                            <AmountIcon />
                          </Tooltip>
                        </Button>

                        <Dropdown
                          menu={{ items }}
                          trigger={["click"]}
                          placement="bottomRight"
                          className="actionButton"
                        >
                          <Button
                            onClick={(x) => {
                              x.stopPropagation();
                              setContactIndex(i);
                              setTableRecord(contact);
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                            style={{
                              padding: "0px",
                              height: "auto",
                              border: "unset",
                              backgroundColor: "transparent",
                            }}
                            ref={dropdownRef}
                            className="only_icon"
                            icon={<MoreOutlined />}
                          />
                        </Dropdown>
                      </div>
                    </div>
                    <div style={{ marginBottom: "20px", height: "24px" }}>
                      {contact?.title && (
                        <Tag
                          className="purple_tag"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            minWidth: "auto",
                            maxWidth: "100%",
                          }}
                        >
                          {contact?.title}
                        </Tag>
                      )}
                    </div>
                    <div className="contactData">
                      <span className="labelText">Phone:</span>
                      <span className="ValueText">
                        {contact?.phone ? (
                          <>
                            <PhoneInput disabled value={contact?.phone} />
                            {contact?.preferred_method_of_contact ===
                              "phone" && <GreenCheckIcon />}
                          </>
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>

                    <div className="contactData">
                      <span className="labelText">Email:</span>
                      <span className="ValueText">
                        {contact?.email ? (
                          <>
                            <span className="truncatedEmail">
                              <Tooltip title={contact.email}>
                                {contact?.email}
                              </Tooltip>
                            </span>
                            {contact?.preferred_method_of_contact ===
                              "email" && (
                              <GreenCheckIcon
                                style={{
                                  marginLeft: "4px",
                                }}
                              />
                            )}
                          </>
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                  </Card>
                ))}
              </div>
            ) : (
              <div className="whenEmpty">
                <Image
                  src="/images/empty-icons/no-active.svg"
                  preview={false}
                />
                <h3> Property has no contacts </h3>
                <p> Enter the contact name in the field above </p>
              </div>
            )}
          </Col>
        )}
      </Row>

      <PopUp {...addNewContact} />
      <PopUp {...confirmDeletePopUp} />
    </>
  );
}
